import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

/**
 * Shown by the route guard (`routes/RequireRole.tsx`) when a signed-in user opens a page their
 * role does not reach. Deliberately not the 404 view: the page exists, it just isn't theirs.
 */
export function NotAuthorized() {
	return (
		<Box
			data-testid="not-authorized"
			sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, mt: 10, px: 2 }}
		>
			<Typography variant="h5">You don&apos;t have access to this page</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
				Your account doesn&apos;t include the role this page needs. If you think it should, contact support@rogoag.com.
			</Typography>
			<Button component={Link} to="/home" variant="contained">
				Go to Home
			</Button>
		</Box>
	);
}
